<!--
 * @Author: cryi.liu
 * @Date: 2020-04-30 11:19:18
 * @LastEditTime: 2020-06-16 14:26:09
 * @Description: 退出系统按钮
 -->
<template>
  <div class="logout-btn" @click="logout">退出系统</div>
</template>

<script>
export default {
  name: 'LogoutBtn',
  methods: {
    logout() {
      window.open('/passportAction.do', '_self');
    },
  },
};
</script>

<style lang="less" scoped>
.logout-btn {
  display: inline-block;
  width: 65px;
  height: 19px;
  text-align: center;
  line-height: 19px;
  background: url('../../../../assets/image/bg-logout-btn.jpg');
  font-size: 11px;
  color: #000;
  cursor: pointer;
}
</style>
